import styled from 'styled-components';
import { Skeleton } from '../Skeleton.styles';

export const StyledSkeleton = styled(Skeleton)`
  width: 100%;
  aspect-ratio: ${({ $aspectRatio }) => $aspectRatio};
  border-radius: 16px;
`;
